import { useMemo } from 'react';
import { ExtendedColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { CounterpartyOptionGroupKey } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/Documents.utils';
import { PersonFilterWithSearch } from './PersonFilterWithSearch';

interface Props<TData, TValue> {
	column: ExtendedColumn<TData, TValue>;
	filterText?: string;
	options: Array<{
		value: string;
		label: string;
		groupKey: CounterpartyOptionGroupKey;
		groupLabel: string;
	}>;
}

export const CounterpartyCombinedFilter = <TData, TValue>({
	column,
	filterText,
	options,
}: Props<TData, TValue>) => {
	const sections = useMemo(() => {
		const statusOptions = options
			.filter((opt) => opt.groupKey === CounterpartyOptionGroupKey.SIGNATURE_STATUS)
			.map((opt) => ({
				value: opt.value.replace('status:', ''),
				label: opt.label,
			}));

		const statusGroupLabel =
			options.find((opt) => opt.groupKey === CounterpartyOptionGroupKey.SIGNATURE_STATUS)
				?.groupLabel ?? 'Filter by signature status';

		const roleOptions = options
			.filter((opt) => opt.groupKey === CounterpartyOptionGroupKey.DOCUMENT_ROLE)
			.map((opt) => ({
				value: opt.value.replace('role:', ''),
				label: opt.label,
			}));

		const roleGroupLabel =
			options.find((opt) => opt.groupKey === CounterpartyOptionGroupKey.DOCUMENT_ROLE)
				?.groupLabel ?? 'Filter by document role';

		return [
			{
				title: statusGroupLabel,
				fieldKey: 'signatureStatuses',
				options: statusOptions,
			},
			{
				title: roleGroupLabel,
				fieldKey: 'roleNames',
				options: roleOptions,
			},
		];
	}, [options]);

	return (
		<PersonFilterWithSearch
			column={column}
			filterText={filterText}
			nameFieldKey="counterpartyName"
			sections={sections}
		/>
	);
};
